import { create } from 'zustand';

export const useAppStore = create((set) => ({
  language: localStorage.getItem('language') || 'ar',
  setLanguage: (lang) => {
    localStorage.setItem('language', lang);
    set({ language: lang });
  },
  
  postUrl: '',
  setPostUrl: (url) => set({ postUrl: url }),
  
  selectedServices: [],
  setSelectedServices: (services) => set({ selectedServices: services }),
  
  comments: [],
  setComments: (comments) => set({ comments }),
  addComment: (comment) => set((state) => ({
    comments: [...state.comments, { ...comment, id: Date.now() }]
  })),
  deleteComment: (id) => set((state) => ({
    comments: state.comments.filter(c => c.id !== id)
  })),
  updateComment: (id, updated) => set((state) => ({
    comments: state.comments.map(c => c.id === id ? { ...c, ...updated } : c)
  })),
  
  users: [],
  setUsers: (users) => set({ users }),
  addUser: (user) => set((state) => ({
    users: [...state.users, { ...user, id: Date.now() }]
  })),
  deleteUser: (id) => set((state) => ({
    users: state.users.filter(u => u.id !== id)
  })),
  updateUser: (id, updated) => set((state) => ({
    users: state.users.map(u => u.id === id ? { ...u, ...updated } : u)
  })),
  
  terminalOutput: [],
  setTerminalOutput: (output) => set({ terminalOutput: output }),
  addTerminalLine: (line) => set((state) => ({
    terminalOutput: [...state.terminalOutput, line]
  })),
  clearTerminal: () => set({ terminalOutput: [] }),
  
  isProcessing: false,
  setIsProcessing: (processing) => set({ isProcessing: processing }),
}));
